import { datadogRum } from "@datadog/browser-rum";
import { datadogLogs } from "@datadog/browser-logs";
let initialized = false;
export const initDatadog = (config)=>{
    if (initialized) return;
    if (!config.applicationId || !config.clientToken || !config.site || !config.service) return;
    datadogRum.init({
        applicationId: config.applicationId,
        clientToken: config.clientToken,
        site: config.site,
        service: config.service,
        env: process.env.NODE_ENV ?? "production",
        sessionSampleRate: 100,
        sessionReplaySampleRate: 20,
        trackUserInteractions: true,
        trackResources: true,
        trackLongTasks: true,
        defaultPrivacyLevel: "mask-user-input"
    });
    datadogLogs.init({
        clientToken: config.clientToken,
        site: config.site,
        service: config.service,
        env: process.env.NODE_ENV ?? "production",
        forwardErrorsToLogs: true,
        sessionSampleRate: 100
    });
    initialized = true;
};
